module.exports = __webpack_public_path__ + "static/armory-45202388e82d6461bb02efbb0590389b.png";